import React from 'react'
import ShiftsFilter from './ShiftsFilter'
import ShiftsTable from './ShiftsTable'
import { CourierWorkShift } from '@@partner:types:app'
import { useFetchAllCourierWorkShifts } from '@@partner:graphql/query/courier/allCourierWorkShifts.gql'
import { useGridHelper } from '@@partner:helpers/crud/grid'
import './ShiftsTableView.scss'

export interface ShiftsTableViewProps {
  onEditShift: (shift: CourierWorkShift) => void
  onDeleteShift: (shift: CourierWorkShift) => void
  onViewShift: (shift: CourierWorkShift) => void
}

export default function ShiftsTableView ({
  onEditShift,
  onDeleteShift,
  onViewShift
}: ShiftsTableViewProps) {
  // Собственное управление состоянием для таблицы
  const { page, tableSort, filter, handlePageSelect, handleSortColumn, handleFilterChanged } =
    useGridHelper({
      defaultSortFieldName: 'ts_starting',
      defaultSortDirection: 0,
      defaultSortType: 'desc',
      defaultLimit: 20,
      defaultLimitOptions: [ 10, 20, 50, 100 ],
      defaultFilter: {}
    })

  // Собственный GraphQL запрос для таблицы
  const { courierWorkshifts, loading, error, data } = useFetchAllCourierWorkShifts({
    filter,
    pager: { page },
    sort: {
      direction: tableSort.direction,
      fieldName: tableSort.fieldName
    }
  })

  const shifts = courierWorkshifts || []
  const pageInfo = data?.allCourierWorkShifts?.pageInfo

  return (
    <div className="shifts-table-view">
      <ShiftsFilter onFilterChanged={handleFilterChanged} />
      
      <ShiftsTable
        data={shifts}
        loading={loading}
        error={error}
        pageInfo={pageInfo}
        tableSort={tableSort}
        page={page}
        onSortColumn={handleSortColumn}
        onPageSelect={handlePageSelect}
        onEditShift={onEditShift}
        onDeleteShift={onDeleteShift}
        onViewShift={onViewShift}
      />
    </div>
  )
}